/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
export function cleanAppearanceParams(location: {
  search: string;
  hash: string;
}) {
  const search = new URLSearchParams(location.search);
  const index = location.hash.indexOf("?");
  const fragment =
    index >= 0 ? new URLSearchParams(location.hash.slice(index + 1)) : null;
  const hasSearch = search.has("lang") || search.has("theme");
  const hasFragment = Boolean(fragment?.has("lang") || fragment?.has("theme"));
  if (!hasSearch && !hasFragment) return location;
  search.delete("lang");
  search.delete("theme");
  fragment?.delete("lang");
  fragment?.delete("theme");
  return {
    search: hasSearch
      ? search.size
        ? "?" + search.toString()
        : ""
      : location.search,
    hash: hasFragment
      ? location.hash.slice(0, index) +
        (fragment?.size ? "?" + fragment.toString() : "")
      : location.hash,
  };
}
